import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { parseEmojiOption } from '~/pages/communication/libs/parseEmojiOption'
import {
  STUDY_GOAL_OPTIONS,
  STUDY_GOAL_QUESTION,
} from '~/pages/communication/studyGoal/libs/components/StudyGoalCommunication/constants'
import { StudyGoalCommunicationStyles as S } from '~/pages/communication/studyGoal/libs/components/StudyGoalCommunication/styles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { eventLogger } from '~/shared/services/eventLogger'
import { TPageProps } from '~/shared/types/commonTypes'

const StudyGoalCommunication = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('communication')
  const [answers, setAnswers] = useState<string[]>([])

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: STUDY_GOAL_QUESTION,
  })

  const handleOptionToggle = (key: string) => {
    setAnswers((prev) =>
      prev.includes(key) ? prev.filter((a) => a !== key) : [...prev, key],
    )
  }

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.ScrollContent>
          <S.TitleGroup>
            <S.Title>
              <Trans
                ns="communication"
                i18nKey="onboarding.communicationStudyGoal.title"
                components={{ br: <br /> }}
              />
            </S.Title>
            <S.Subtitle>
              <Trans
                ns="communication"
                i18nKey="onboarding.communicationStudyGoal.subtitle"
              />
            </S.Subtitle>
          </S.TitleGroup>

          <S.OptionsGrid>
            {STUDY_GOAL_OPTIONS.map(({ key, i18nKey }) => {
              const isSelected = answers.includes(key)
              const { emoji, label } = parseEmojiOption(
                t(`onboarding.communicationStudyGoal.options.${i18nKey}`),
              )

              return (
                <S.OptionButton
                  key={key}
                  type="button"
                  $isSelected={isSelected}
                  onClick={() => handleOptionToggle(key)}
                >
                  <S.OptionEmoji>{emoji}</S.OptionEmoji>
                  <S.OptionLabel $isSelected={isSelected}>
                    {label}
                  </S.OptionLabel>
                </S.OptionButton>
              )
            })}
          </S.OptionsGrid>
        </S.ScrollContent>

        <S.ButtonWrapper>
          <S.Button
            type="button"
            disabled={!answers.length}
            onClick={() => {
              eventLogger.logBiUserGoal(answers)
              handleContinue(answers)
            }}
          >
            <Trans i18nKey="actions.continue" />
          </S.Button>
        </S.ButtonWrapper>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default StudyGoalCommunication
